/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/search-form-keyword.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../src/app/search-panel/services/search-form.service';
import * as import10 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import11 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import15 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import16 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/reactive_directives/form_control_directive.ngfactory';
import * as import17 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import18 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import19 from '@angular/core/src/linker/template_ref';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/common/src/directives/ng_for';
import * as import22 from '@angular/forms/src/directives/control_value_accessor';
import * as import23 from '@angular/forms/src/directives/reactive_directives/form_control_directive';
import * as import24 from '@angular/forms/src/directives/ng_control';
import * as import25 from '@angular/forms/src/directives/ng_control_status';
import * as import26 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import27 from '../../../../../$$_gendir/node_modules/angular2-text-mask/dist/angular2TextMask.ngfactory';
import * as import28 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import29 from '@angular/forms/src/directives/default_value_accessor';
import * as import30 from 'angular2-text-mask/dist/angular2TextMask';
import * as import31 from '@angular/common/src/directives/ng_if';
import * as import32 from 'ng2-translate/src/translate.pipe';
import * as import33 from 'ng2-translate/src/translate.service';
import * as import34 from '../directives/date-picker.directive.ngfactory';
import * as import35 from '../../../../../src/app/search-panel/services/date.service';
import * as import36 from '../../../../../src/app/search-panel/directives/date-picker.directive';
import * as import37 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import38 from '@angular/common/src/directives/ng_switch';
export class Wrapper_SearchFormKeywordComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SearchFormKeywordComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.SearchFormKeywordComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_keyword(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.keyword = currValue;
      this._expr_0 = currValue;
    }
  }
  check_keywordFormControl(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.keywordFormControl = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_SearchFormKeywordComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SearchFormKeywordComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SearchFormKeywordComponent>;
  _SearchFormKeywordComponent_0_3:Wrapper_SearchFormKeywordComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormKeywordComponent_Host0,renderType_SearchFormKeywordComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-search-form-keyword',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SearchFormKeywordComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchFormKeywordComponent_0_3 = new Wrapper_SearchFormKeywordComponent(this.injectorGet(import9.SearchFormService,this.parentIndex));
    this.compView_0.create(this._SearchFormKeywordComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SearchFormKeywordComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchFormKeywordComponent) && (0 === requestNodeIndex))) { return this._SearchFormKeywordComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchFormKeywordComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SearchFormKeywordComponentNgFactory:import8.ComponentFactory<import0.SearchFormKeywordComponent> = new import8.ComponentFactory<import0.SearchFormKeywordComponent>('obpa-search-form-keyword',View_SearchFormKeywordComponent_Host0,import0.SearchFormKeywordComponent);
const styles_SearchFormKeywordComponent:any[] = ([] as any[]);
class View_SearchFormKeywordComponent2 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import10.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import11.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent2,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import10.Wrapper_NgSelectOption(new import13.ElementRef(this._el_0),this.renderer,(<View_SearchFormKeywordComponent1>this.parentView)._SelectControlValueAccessor_1_3.context);
    this._NgSelectMultipleOption_0_4 = new import11.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import15.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent1 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _SelectControlValueAccessor_1_3:import10.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _NgSelectOption_3_3:import10.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_3_4:import11.Wrapper_NgSelectMultipleOption;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import18.Wrapper_NgFor;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent1,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'select',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._SelectControlValueAccessor_1_3 = new import10.Wrapper_SelectControlValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._SelectControlValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_1,'option',new import3.InlineArray2(2,'value',''),(null as any));
    this._NgSelectOption_3_3 = new import10.Wrapper_NgSelectOption(new import13.ElementRef(this._el_3),this.renderer,this._SelectControlValueAccessor_1_3.context);
    this._NgSelectMultipleOption_3_4 = new import11.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_3),this.renderer,(null as any));
    this._text_4 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._vc_5 = new import12.ViewContainer(5,1,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import18.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import20.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_1,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.NgSelectOption) && (3 === requestNodeIndex))) { return this._NgSelectOption_3_3.context; }
    if (((token === import15.NgSelectMultipleOption) && (3 === requestNodeIndex))) { return this._NgSelectMultipleOption_3_4.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import21.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    if (((token === import14.SelectControlValueAccessor) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._SelectControlValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgControlStatus_1_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SelectControlValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_3_0_0:any = '';
    this._NgSelectOption_3_3.check_value(currVal_3_0_0,throwOnChange,false);
    this._NgSelectOption_3_3.ngDoCheck(this,this._el_3,throwOnChange);
    const currVal_3_1_0:any = '';
    this._NgSelectMultipleOption_3_4.check_value(currVal_3_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_3_4.ngDoCheck(this,this._el_3,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.keyword.dataset;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_18:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_18);
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    const currVal_20:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_20 == null)? (null as any): currVal_20.toString()));
      this._expr_20 = currVal_20;
    }
    const currVal_21:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_21 == null)? (null as any): currVal_21.toString()));
      this._expr_21 = currVal_21;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._NgSelectOption_3_3.ngOnDestroy();
    this._NgSelectMultipleOption_3_4.ngOnDestroy();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent2(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent4,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'\n                (',this.parentView.parentView.context.keyword.mask.helpText,')\n            ');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent3 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _MaskedInputDirective_1_4:import27.Wrapper_MaskedInputDirective;
  _NG_VALUE_ACCESSOR_1_5:any[];
  _FormControlDirective_1_6:import16.Wrapper_FormControlDirective;
  _NgControl_1_7:any;
  _NgControlStatus_1_8:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent3,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._MaskedInputDirective_1_4 = new import27.Wrapper_MaskedInputDirective(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_5 = [
      this._DefaultValueAccessor_1_3.context,
      this._MaskedInputDirective_1_4.context
    ]
    ;
    this._FormControlDirective_1_6 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_5);
    this._NgControl_1_7 = this._FormControlDirective_1_6.context;
    this._NgControlStatus_1_8 = new import17.Wrapper_NgControlStatus(this._NgControl_1_7);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import30.MaskedInputDirective) && (1 === requestNodeIndex))) { return this._MaskedInputDirective_1_4.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_5; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_6.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_7; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_8.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keyword.mask.textMaskConfig;
    this._MaskedInputDirective_1_4.check_textMaskConfig(currVal_1_1_0,throwOnChange,false);
    this._MaskedInputDirective_1_4.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_2_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_6.check_form(currVal_1_2_0,throwOnChange,false);
    this._FormControlDirective_1_6.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_8.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:boolean = !this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'required');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_17:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    const currVal_20:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_20 == null)? (null as any): currVal_20.toString()));
      this._expr_20 = currVal_20;
    }
    this._NgControlStatus_1_8.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_21:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_21);
      this._expr_21 = currVal_21;
    }
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._MaskedInputDirective_1_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_6.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent4(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    result = (this._MaskedInputDirective_1_4.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent6,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {digits: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID NUMERIC',this._map_3(9))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent5 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent5,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'pattern');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_16:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_17 == null)? (null as any): currVal_17.toString()));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_20:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent6(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent8 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent8,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {digits: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID NUMERIC',this._map_3(20))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent7 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent7,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'pattern');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_16:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_17 == null)? (null as any): currVal_17.toString()));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_20:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent8(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent10 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent10,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {format: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID DATE',this._map_3('mm/dd/yyyy'))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent9 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _DatePickerDirective_1_8:import34.Wrapper_DatePickerDirective;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent9,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray4(4,'class','form-control','obpaDatePicker',''),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._DatePickerDirective_1_8 = new import34.Wrapper_DatePickerDirective(new import13.ElementRef(this._el_1),this._NgControl_1_6,this.parentView.parentView.injectorGet(import35.DateService,this.parentView.parentIndex));
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import36.DatePickerDirective) && (1 === requestNodeIndex))) { return this._DatePickerDirective_1_8.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    this._DatePickerDirective_1_8.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'invalidDate');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_17:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    const currVal_20:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_20 == null)? (null as any): currVal_20.toString()));
      this._expr_20 = currVal_20;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_21:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_21);
      this._expr_21 = currVal_21;
    }
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._DatePickerDirective_1_8.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
    this._DatePickerDirective_1_8.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent10(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent12 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent12,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID CURRENCY')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent11 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent11,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'pattern');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_16:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_17 == null)? (null as any): currVal_17.toString()));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_20:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent12(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent14 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent14,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID FLOAT')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent13 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent13,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'pattern');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_16:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_17 == null)? (null as any): currVal_17.toString()));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_20:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent14(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent16 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent16,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {chars: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID LENGTH',this._map_3(this.parentView.parentView.context.keyword.maxLength))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormKeywordComponent15 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _DefaultValueAccessor_1_3:import26.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_1_4:any[];
  _FormControlDirective_1_5:import16.Wrapper_FormControlDirective;
  _NgControl_1_6:any;
  _NgControlStatus_1_7:import17.Wrapper_NgControlStatus;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import28.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  /*private*/ _expr_20:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent15,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
    this._expr_20 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'input',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._DefaultValueAccessor_1_3 = new import26.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_1));
    this._NG_VALUE_ACCESSOR_1_4 = [this._DefaultValueAccessor_1_3.context];
    this._FormControlDirective_1_5 = new import16.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_1_4);
    this._NgControl_1_6 = this._FormControlDirective_1_5.context;
    this._NgControlStatus_1_7 = new import17.Wrapper_NgControlStatus(this._NgControl_1_6);
    this._text_2 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,(null as any),'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._vc_5 = new import12.ViewContainer(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import28.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_7 = this.renderer.createText((null as any),'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_1,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_1));
    this.init(this._text_7,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.DefaultValueAccessor) && (1 === requestNodeIndex))) { return this._DefaultValueAccessor_1_3.context; }
    if (((token === import22.NG_VALUE_ACCESSOR) && (1 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_1_4; }
    if (((token === import23.FormControlDirective) && (1 === requestNodeIndex))) { return this._FormControlDirective_1_5.context; }
    if (((token === import24.NgControl) && (1 === requestNodeIndex))) { return this._NgControl_1_6; }
    if (((token === import25.NgControlStatus) && (1 === requestNodeIndex))) { return this._NgControlStatus_1_7.context; }
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import31.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_1_3.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_1_1_0:any = this.parentView.context.keywordFormControl;
    this._FormControlDirective_1_5.check_form(currVal_1_1_0,throwOnChange,false);
    this._FormControlDirective_1_5.ngDoCheck(this,this._el_1,throwOnChange);
    this._NgControlStatus_1_7.ngDoCheck(this,this._el_1,throwOnChange);
    const currVal_5_0_0:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl,'maxlength');
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_16:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_1,'id',currVal_16);
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = this.parentView.context.keyword.required;
    if (import3.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementAttribute(this._el_1,'aria-required',((currVal_17 == null)? (null as any): currVal_17.toString()));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = this.parentView.context.searchForm.ctrlHasError(this.parentView.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementAttribute(this._el_1,'aria-invalid',((currVal_18 == null)? (null as any): currVal_18.toString()));
      this._expr_18 = currVal_18;
    }
    const currVal_19:any = import3.inlineInterpolate(2,'obpa_kw_',this.parentView.context.keyword.id,'_err obpa_kw_',this.parentView.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_1,'aria-describedby',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_1_7.checkHost(this,this,this._el_1,throwOnChange);
    const currVal_20:any = import3.inlineInterpolate(1,'obpa_kw_',this.parentView.context.keyword.id,'_err');
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementProperty(this._el_3,'id',currVal_20);
      this._expr_20 = currVal_20;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._FormControlDirective_1_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_2,ctx);
    cb(this._el_3,ctx);
    cb(this._text_7,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent16(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_1(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_1_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
class View_SearchFormKeywordComponent17 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SearchFormKeywordComponent17,renderType_SearchFormKeywordComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import33.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: REQUIRED KEYWORD')),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_SearchFormKeywordComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SearchFormKeywordComponent,{});
export class View_SearchFormKeywordComponent0 extends import2.AppView<import0.SearchFormKeywordComponent> {
  _el_0:any;
  _NgSwitch_0_3:import37.Wrapper_NgSwitch;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import12.ViewContainer;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import37.Wrapper_NgSwitchCase;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import12.ViewContainer;
  _TemplateRef_7_5:any;
  _NgSwitchCase_7_6:import37.Wrapper_NgSwitchCase;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import12.ViewContainer;
  _TemplateRef_9_5:any;
  _NgSwitchCase_9_6:import37.Wrapper_NgSwitchCase;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import12.ViewContainer;
  _TemplateRef_11_5:any;
  _NgSwitchCase_11_6:import37.Wrapper_NgSwitchCase;
  _text_12:any;
  _anchor_13:any;
  /*private*/ _vc_13:import12.ViewContainer;
  _TemplateRef_13_5:any;
  _NgSwitchCase_13_6:import37.Wrapper_NgSwitchCase;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _vc_15:import12.ViewContainer;
  _TemplateRef_15_5:any;
  _NgSwitchCase_15_6:import37.Wrapper_NgSwitchCase;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _vc_17:import12.ViewContainer;
  _TemplateRef_17_5:any;
  _NgSwitchCase_17_6:import37.Wrapper_NgSwitchCase;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _vc_19:import12.ViewContainer;
  _TemplateRef_19_5:any;
  _NgSwitchCase_19_6:import37.Wrapper_NgSwitchCase;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _vc_23:import12.ViewContainer;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import28.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_54:any;
  /*private*/ _expr_55:any;
  /*private*/ _expr_56:any;
  /*private*/ _expr_57:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormKeywordComponent0,renderType_SearchFormKeywordComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_54 = import1.UNINITIALIZED;
    this._expr_55 = import1.UNINITIALIZED;
    this._expr_56 = import1.UNINITIALIZED;
    this._expr_57 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_0_3 = new import37.Wrapper_NgSwitch();
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'label',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import12.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this,5,this._anchor_5);
    this._NgSwitchCase_5_6 = new import37.Wrapper_NgSwitchCase(this._vc_5.vcRef,this._TemplateRef_5_5,this._NgSwitch_0_3.context);
    this._text_6 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_7 = new import12.ViewContainer(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import19.TemplateRef_(this,7,this._anchor_7);
    this._NgSwitchCase_7_6 = new import37.Wrapper_NgSwitchCase(this._vc_7.vcRef,this._TemplateRef_7_5,this._NgSwitch_0_3.context);
    this._text_8 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_9 = new import12.ViewContainer(9,0,this,this._anchor_9);
    this._TemplateRef_9_5 = new import19.TemplateRef_(this,9,this._anchor_9);
    this._NgSwitchCase_9_6 = new import37.Wrapper_NgSwitchCase(this._vc_9.vcRef,this._TemplateRef_9_5,this._NgSwitch_0_3.context);
    this._text_10 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_11 = new import12.ViewContainer(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import19.TemplateRef_(this,11,this._anchor_11);
    this._NgSwitchCase_11_6 = new import37.Wrapper_NgSwitchCase(this._vc_11.vcRef,this._TemplateRef_11_5,this._NgSwitch_0_3.context);
    this._text_12 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_13 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_13 = new import12.ViewContainer(13,0,this,this._anchor_13);
    this._TemplateRef_13_5 = new import19.TemplateRef_(this,13,this._anchor_13);
    this._NgSwitchCase_13_6 = new import37.Wrapper_NgSwitchCase(this._vc_13.vcRef,this._TemplateRef_13_5,this._NgSwitch_0_3.context);
    this._text_14 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_15 = new import12.ViewContainer(15,0,this,this._anchor_15);
    this._TemplateRef_15_5 = new import19.TemplateRef_(this,15,this._anchor_15);
    this._NgSwitchCase_15_6 = new import37.Wrapper_NgSwitchCase(this._vc_15.vcRef,this._TemplateRef_15_5,this._NgSwitch_0_3.context);
    this._text_16 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_17 = new import12.ViewContainer(17,0,this,this._anchor_17);
    this._TemplateRef_17_5 = new import19.TemplateRef_(this,17,this._anchor_17);
    this._NgSwitchCase_17_6 = new import37.Wrapper_NgSwitchCase(this._vc_17.vcRef,this._TemplateRef_17_5,this._NgSwitch_0_3.context);
    this._text_18 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_19 = new import12.ViewContainer(19,0,this,this._anchor_19);
    this._TemplateRef_19_5 = new import19.TemplateRef_(this,19,this._anchor_19);
    this._NgSwitchCase_19_6 = new import37.Wrapper_NgSwitchCase(this._vc_19.vcRef,this._TemplateRef_19_5,this._NgSwitch_0_3.context);
    this._text_20 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21,(null as any));
    this._vc_23 = new import12.ViewContainer(23,21,this,this._anchor_23);
    this._TemplateRef_23_5 = new import19.TemplateRef_(this,23,this._anchor_23);
    this._NgIf_23_6 = new import28.Wrapper_NgIf(this._vc_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_21,'\n    ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._anchor_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._anchor_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import38.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    if (((token === import19.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import38.NgSwitchCase) && (7 === requestNodeIndex))) { return this._NgSwitchCase_7_6.context; }
    if (((token === import19.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import38.NgSwitchCase) && (9 === requestNodeIndex))) { return this._NgSwitchCase_9_6.context; }
    if (((token === import19.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import38.NgSwitchCase) && (11 === requestNodeIndex))) { return this._NgSwitchCase_11_6.context; }
    if (((token === import19.TemplateRef) && (13 === requestNodeIndex))) { return this._TemplateRef_13_5; }
    if (((token === import38.NgSwitchCase) && (13 === requestNodeIndex))) { return this._NgSwitchCase_13_6.context; }
    if (((token === import19.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import38.NgSwitchCase) && (15 === requestNodeIndex))) { return this._NgSwitchCase_15_6.context; }
    if (((token === import19.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import38.NgSwitchCase) && (17 === requestNodeIndex))) { return this._NgSwitchCase_17_6.context; }
    if (((token === import19.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import38.NgSwitchCase) && (19 === requestNodeIndex))) { return this._NgSwitchCase_19_6.context; }
    if (((token === import19.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import31.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    if (((token === import38.NgSwitch) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 25)))) { return this._NgSwitch_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.keywordSimpleType;
    this._NgSwitch_0_3.check_ngSwitch(currVal_0_0_0,throwOnChange,false);
    this._NgSwitch_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_5_0_0:any = 'Dataset';
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = 'Mask';
    this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0,throwOnChange,false);
    this._NgSwitchCase_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = 'SmallNumeric';
    this._NgSwitchCase_9_6.check_ngSwitchCase(currVal_9_0_0,throwOnChange,false);
    this._NgSwitchCase_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:any = 'LargeNumeric';
    this._NgSwitchCase_11_6.check_ngSwitchCase(currVal_11_0_0,throwOnChange,false);
    this._NgSwitchCase_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    const currVal_13_0_0:any = 'Date';
    this._NgSwitchCase_13_6.check_ngSwitchCase(currVal_13_0_0,throwOnChange,false);
    this._NgSwitchCase_13_6.ngDoCheck(this,this._anchor_13,throwOnChange);
    const currVal_15_0_0:any = 'Currency';
    this._NgSwitchCase_15_6.check_ngSwitchCase(currVal_15_0_0,throwOnChange,false);
    this._NgSwitchCase_15_6.ngDoCheck(this,this._anchor_15,throwOnChange);
    const currVal_17_0_0:any = 'Float';
    this._NgSwitchCase_17_6.check_ngSwitchCase(currVal_17_0_0,throwOnChange,false);
    this._NgSwitchCase_17_6.ngDoCheck(this,this._anchor_17,throwOnChange);
    const currVal_19_0_0:any = 'AlphaNumeric';
    this._NgSwitchCase_19_6.check_ngSwitchCase(currVal_19_0_0,throwOnChange,false);
    this._NgSwitchCase_19_6.ngDoCheck(this,this._anchor_19,throwOnChange);
    const currVal_23_0_0:any = this.context.searchForm.ctrlHasError(this.context.keywordFormControl,'required');
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.ngDoCheck(this,this._anchor_23,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    this._vc_13.detectChangesInNestedViews(throwOnChange);
    this._vc_15.detectChangesInNestedViews(throwOnChange);
    this._vc_17.detectChangesInNestedViews(throwOnChange);
    this._vc_19.detectChangesInNestedViews(throwOnChange);
    this._vc_23.detectChangesInNestedViews(throwOnChange);
    const currVal_54:any = this.context.searchForm.ctrlHasError(this.context.keywordFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_54,currVal_54)) {
      this.renderer.setElementClass(this._el_0,'has-error',currVal_54);
      this._expr_54 = currVal_54;
    }
    const currVal_55:any = import3.inlineInterpolate(1,'obpa_kw_',this.context.keyword.id,'');
    if (import3.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setElementAttribute(this._el_2,'for',((currVal_55 == null)? (null as any): currVal_55.toString()));
      this._expr_55 = currVal_55;
    }
    const currVal_56:any = import3.inlineInterpolate(1,'',this.context.keyword.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_56,currVal_56)) {
      this.renderer.setText(this._text_3,currVal_56);
      this._expr_56 = currVal_56;
    }
    const currVal_57:any = import3.inlineInterpolate(1,'obpa_kw_',this.context.keyword.id,'_err_common');
    if (import3.checkBinding(throwOnChange,this._expr_57,currVal_57)) {
      this.renderer.setElementProperty(this._el_21,'id',currVal_57);
      this._expr_57 = currVal_57;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._vc_7.destroyNestedViews();
    this._vc_9.destroyNestedViews();
    this._vc_11.destroyNestedViews();
    this._vc_13.destroyNestedViews();
    this._vc_15.destroyNestedViews();
    this._vc_17.destroyNestedViews();
    this._vc_19.destroyNestedViews();
    this._vc_23.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_SearchFormKeywordComponent1(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    if ((nodeIndex == 7)) { return new View_SearchFormKeywordComponent3(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    if ((nodeIndex == 9)) { return new View_SearchFormKeywordComponent5(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    if ((nodeIndex == 11)) { return new View_SearchFormKeywordComponent7(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    if ((nodeIndex == 13)) { return new View_SearchFormKeywordComponent9(this.viewUtils,this,13,this._anchor_13,this._vc_13); }
    if ((nodeIndex == 15)) { return new View_SearchFormKeywordComponent11(this.viewUtils,this,15,this._anchor_15,this._vc_15); }
    if ((nodeIndex == 17)) { return new View_SearchFormKeywordComponent13(this.viewUtils,this,17,this._anchor_17,this._vc_17); }
    if ((nodeIndex == 19)) { return new View_SearchFormKeywordComponent15(this.viewUtils,this,19,this._anchor_19,this._vc_19); }
    if ((nodeIndex == 23)) { return new View_SearchFormKeywordComponent17(this.viewUtils,this,23,this._anchor_23,this._vc_23); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/search-form-keyword.component.ngfactory.ts